import DOMHelpers from '../utils/dom-helpers';

export default class{

    constructor( options ) {
        this.defaults = {
        	el: false,
            main: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'simple-toggle';
		this.el 			= 	this.options.el;
		this.main			=   this.options.main;

        this.dom            =   new DOMHelpers( document );

		this.trigger 		= 	this.dom.qs(  '.trigger', this.el ) ? this.dom.qs(  '.trigger', this.el ) :  this.el;
		this.toggle		    = 	this.el.getAttribute( 'data-toggle-element' )? this.dom.qs(  '.' + this.el.getAttribute( 'data-toggle-element' ), this.el ):this.el;
		this.toggleClass    =   this.el.getAttribute( 'data-toggle-class' )?this.el.getAttribute( 'data-toggle-class' ):'open';
		this.plus 			= 	this.el.getAttribute( 'data-plus' )?this.el.getAttribute( 'data-plus' ):false; 
		this.minus 			= 	this.el.getAttribute( 'data-minus' )?this.el.getAttribute( 'data-minus' ):false; 

		this.init();
    }

    init(){
    	this.addEvents( true );
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.dom.on( this.trigger, 'click', this.onChange );
		}
		else{
			this.dom.off( this.trigger, 'click', this.onChange );
		}
	}

	onChange = () => {
		this.dom.toggleClass( this.toggle, this.toggleClass );
		this.dom.toggleClass( this.el, this.toggleClass );

		if ( this.timeout_overflow ) {
			clearTimeout( this.timeout_overflow );
		}
		if ( this.dom.hasClass( this.toggle, this.toggleClass  ) ){
			this.timeout_overflow = setTimeout( ()=> this.dom.addClass( this.toggle, 'show-overflow' ), 400 );
			if ( this.minus ){
				this.dom.qs( '.plus', this.el ).innerHTML( this.minus );
			}
		}
		else{
			this.dom.removeClass( this.toggle, 'show-overflow' );
			if ( this.plus ){
                this.dom.qs( '.plus', this.el ).innerHTML( this.plus );
			}
		}
 	}

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
    	this.addEvents( false );
    }

}